import { render, staticRenderFns } from "./NewOrderConfirmFOBDialog.vue?vue&type=template&id=83b3ae8e&"
import script from "./NewOrderConfirmFOBDialog.vue?vue&type=script&lang=js&"
export * from "./NewOrderConfirmFOBDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports